import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { companyIndustries, companySize } from 'api/login';
// button
import GlButton from '@/components/gl-button';
export default {
  components: {
    GlButton: GlButton
  },
  data: function data() {
    return {
      ruleForm: {
        name: '',
        admin_name: '',
        email: '',
        industry: '',
        size: ''
      },
      industries: [],
      size: [],
      // 校验规则
      rules: {
        name: [{
          required: true,
          message: this.$t('login.19'),
          trigger: 'blur'
        }],
        admin_name: [{
          required: true,
          message: this.$t('login.20'),
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: this.$t('login.21'),
          trigger: 'blur'
        }],
        industry: [{
          required: true,
          message: this.$t('login.22'),
          trigger: 'change'
        }],
        size: [{
          required: true,
          message: this.$t('login.23'),
          trigger: 'change'
        }]
      },
      // 按钮loading
      loading: false
    };
  },
  created: function created() {
    this.init();
  },
  computed: {
    isClick: function isClick() {
      var _this$ruleForm = this.ruleForm,
        name = _this$ruleForm.name,
        admin_name = _this$ruleForm.admin_name,
        email = _this$ruleForm.email,
        industry = _this$ruleForm.industry,
        size = _this$ruleForm.size;
      var status = name && admin_name && email && industry && size;
      return !status;
    }
  },
  methods: {
    init: function init() {
      var _this = this;
      // 行业
      companyIndustries().then(function (res) {
        _this.industries = res.data;
      });
      // 规模
      companySize().then(function (res) {
        _this.size = res.data;
      });
    },
    // 账号登录
    handleLogin: function handleLogin() {
      this.$router.push({
        path: '/register/success'
      });
    }
  }
};